/* istanbul ignore file */
import { fetch } from 'src/services/apollo-fetch';
import { Query } from '../_api';

export default {
  async fetchError(context, data) {
    const response = await fetch.query({
      query: Query.getError,
      variables: { id: data.id },
    });
    // eslint-disable-next-line no-underscore-dangle
    return response.data._error;
  },
};
